import Reveal from "@/components/base/Reveal";
import SectionLabel from "@/components/base/SectionLabel";

const principles = [
  {
    title: "Qualidade",
    description: "Seleção de produtos de acordo com as demandas do mercado.",
  },
  {
    title: "Competitividade",
    description: "Busca por condições comerciais adequadas às operações.",
  },
  {
    title: "Relacionamento",
    description: "Atendimento próximo e eficiente.",
  },
  {
    title: "Diversidade",
    description: "Portfólio voltado para diferentes categorias e segmentos.",
  },
];

export default function Principles() {
  return (
    <section id="como-trabalhamos" className="relative bg-background-100 pt-16 pb-12 md:pt-20 md:pb-14 lg:pt-24 lg:pb-16">
      <span
        className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-px w-2/3 bg-gradient-to-r from-transparent via-accent-500/25 to-transparent"
        aria-hidden="true"
      />
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <Reveal className="max-w-2xl">
          <SectionLabel>Princípios</SectionLabel>
          <h2 className="mt-5 font-heading text-3xl font-medium leading-[1.15] text-foreground-950 md:text-5xl">
            Como trabalhamos
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-y-10 md:mt-20 md:grid-cols-2 lg:grid-cols-4 lg:gap-y-0">
          {principles.map((item, index) => (
            <Reveal
              key={item.title}
              delay={index * 100}
              className={`px-0 md:px-7 lg:px-8 ${
                index !== 0 ? "lg:border-l lg:border-background-300" : ""
              } ${index === 0 ? "lg:pl-0" : ""}`}
            >
              <span className="font-heading text-lg text-accent-600">0{index + 1}</span>
              <h3 className="mt-4 font-heading text-2xl font-medium text-foreground-950 md:text-[1.7rem]">
                {item.title}
              </h3>
              <span className="mt-4 block h-px w-10 bg-accent-500" />
              <p className="mt-5 max-w-xs text-sm leading-relaxed text-foreground-600">{item.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}